import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getStorage } from './utils';
import constant from './constant'
import { ToastProvider } from './context/ToastContext';
//#region components

// public routes
import HeterIskaSignature from './container/public/HeterIskaSignature';
// public routes

// misc
import FourZeroFour from './container/misc/FourZeroFour';
// misc

// auth
import Login from './container/auth/Login';
import Logout from './container/auth/Logout';
import ForgotPassword from './container/auth/ForgotPassword';
import Register from './container/auth/Register';
import ResetPassword from './container/auth/ResetPassword';
// auth

// message
// import MessageList from './container/message/List';
// message

// loan
import LoanList from './container/loan/List';
import FeedbackThanks from './container/public/FeedbackThanks';
// loan

//#endregion components
const token = getStorage(constant.key.token);
const { io } = require("socket.io-client");
const socket = io(process.env.REACT_APP_SOCKET_URL, { query: { token, customer: true } });

const PrivateRoute = (props: any) => {

    if (token) {
        return (
            <Route
                exact={true}
                path={props.path}
                // component={props.component}
                render={() => <props.component {...props} match={props.computedMatch} socket={socket} />}
            />
        )
    } else {
        return <Login returnUrl={props.path} />
    }
}

class Router extends React.Component<any, any> {
    render() {
        return (
            <React.Fragment>
                <ToastProvider >
                    <Switch>
                        {/* auth route */}
                        <Route exact={true} path={constant.component.login.url} component={Login} />
                        <Route exact={true} path={constant.component.logout.url} component={Logout} />
                        <Route exact={true} path={constant.component.forgotPassword.url} component={ForgotPassword} />
                        <Route exact={true} path={constant.component.resetPassword.url} component={ResetPassword} />
                        <Route exact={true} path={constant.component.register.url} component={Register} />
                        {/* auth route */}

                        <Route exact={true} path={constant.component.heterIskaSignature.url} component={HeterIskaSignature} />
                        <Route exact={true} path={constant.component.feedbackThanks.url} component={FeedbackThanks} />

                        {/* loan */}
                        <PrivateRoute exact={true} path={constant.component.loanList.url} component={LoanList} />
                        {/* loan */}

                        <Route component={FourZeroFour} />
                    </Switch>
                </ToastProvider>
            </React.Fragment>
        );
    }

}

export default Router;